import { Injectable } from '@angular/core';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string, columnOrder?: string[]): void {
    // Use the specified column order if provided, otherwise use the order of the first item in the JSON array
    const effectiveColumnOrder: string[] = columnOrder || (json.length > 0 ? Object.keys(json[0]) : []);

    // Create a custom worksheet with columns in the effective order
    const customWorksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, { header: effectiveColumnOrder });

    // Create a workbook with the custom worksheet
    const workbook: XLSX.WorkBook = { Sheets: { 'data': customWorksheet }, SheetNames: ['data'] };

    // Convert the workbook to Excel format
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Save the Excel file
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
  
}